import { axios } from '@/di-container/axios';
import {
  GetShopSidoGateway,
  GetShopGunGusGateway,
  GetShopListGateway,
  GetShopClusterListGateway,
  GetDisplayShopListGateway,
} from '@remodeling/shop';

export const shopSearchGateway = () => {
  return {
    getSidoData: new GetShopSidoGateway(axios),
    getGunGuData: new GetShopGunGusGateway(axios),
    getShopListData: new GetShopListGateway(axios),
    getDisplayShopListData: new GetDisplayShopListGateway(axios),
    getShopClusterListData: new GetShopClusterListGateway(axios),
  };
};
